import type { AdTrustAudit } from "./types";

const checkedAt = "2026-06-14T10:23:00.000Z";

export const sampleAudit: AdTrustAudit = {
  domain: "example.com",
  checkedAt,
  score: 84,
  scoreLabel: "Good",
  fetches: {
    httpsAds: {
      label: "HTTPS ads.txt",
      url: "https://example.com/ads.txt",
      finalUrl: "https://example.com/ads.txt",
      status: 200,
      ok: true,
      contentType: "text/plain; charset=utf-8",
      bytes: 238,
      elapsedMs: 371,
      body: "",
      error: ""
    },
    httpAds: {
      label: "HTTP ads.txt",
      url: "http://example.com/ads.txt",
      finalUrl: "https://example.com/ads.txt",
      status: 301,
      ok: true,
      contentType: "text/plain; charset=utf-8",
      bytes: 238,
      elapsedMs: 402,
      body: "",
      error: ""
    },
    appAds: {
      label: "app-ads.txt",
      url: "https://example.com/app-ads.txt",
      finalUrl: "https://example.com/app-ads.txt",
      status: 404,
      ok: false,
      contentType: "text/html",
      bytes: 0,
      elapsedMs: 188,
      body: "",
      error: "Not found"
    },
    robots: {
      label: "robots.txt",
      url: "https://example.com/robots.txt",
      finalUrl: "https://example.com/robots.txt",
      status: 200,
      ok: true,
      contentType: "text/plain",
      bytes: 80,
      elapsedMs: 96,
      body: "User-agent: *\nAllow: /ads.txt\nDisallow: /private",
      error: ""
    }
  },
  ads: {
    entries: [
      {
        line: 1,
        raw: "google.com, pub-1234567890123456, DIRECT, f08c47fec0942fa0",
        exchange: "google.com",
        accountId: "pub-1234567890123456",
        relationship: "DIRECT",
        tagId: "f08c47fec0942fa0",
        extensions: [],
        level: "pass",
        issue: "Authorized"
      },
      {
        line: 2,
        raw: "google.com, pub-1234567890123456, RESELLER, abcdef123456",
        exchange: "google.com",
        accountId: "pub-1234567890123456",
        relationship: "RESELLER",
        tagId: "abcdef123456",
        extensions: [],
        level: "warn",
        issue: "Multiple Google entries"
      },
      {
        line: 3,
        raw: "mediavine.com, 12345, DIRECT, 123abc456def789ghi",
        exchange: "mediavine.com",
        accountId: "12345",
        relationship: "DIRECT",
        tagId: "123abc456def789ghi",
        extensions: [],
        level: "pass",
        issue: "Authorized"
      },
      {
        line: 4,
        raw: "appnexus.com, 10260, RESELLER",
        exchange: "appnexus.com",
        accountId: "10260",
        relationship: "RESELLER",
        tagId: "",
        extensions: [],
        level: "warn",
        issue: "Missing TAG ID"
      }
    ],
    directives: [
      { line: 5, name: "OWNERDOMAIN", value: "example.com", country: "US", level: "pass", issue: "Owner domain declared" }
    ],
    comments: 1,
    empty: 1,
    malformed: [],
    duplicateKeys: ["google.com|pub-1234567890123456"],
    hasBom: false,
    hasInvalidCharacters: false
  },
  appAds: {
    entries: [],
    directives: [],
    comments: 0,
    empty: 0,
    malformed: [],
    duplicateKeys: [],
    hasBom: false,
    hasInvalidCharacters: false
  },
  publisher: {
    publisherId: "pub-1234567890123456",
    formatValid: true,
    found: true,
    relationship: "DIRECT",
    line: 1,
    expectedLine: "google.com, pub-1234567890123456, DIRECT, f08c47fec0942fa0",
    sellersJson: {
      status: "info",
      checked: true,
      found: true,
      source: "https://realtimebidding.google.com/sellers.json",
      detail: "Publisher ID sample found in seller transparency data."
    }
  },
  robots: {
    status: "pass",
    found: true,
    blockedAgents: [],
    allowedAgents: ["*", "Googlebot", "Mediapartners-Google"],
    findings: [{ level: "pass", title: "ads.txt is crawlable", detail: "No blocking robots.txt rule matched /ads.txt.", location: "robots.txt" }]
  },
  issues: [
    { level: "warn", title: "Multiple Google entries", detail: "Consider using one Google AdSense DIRECT line unless a partner requires another entry.", location: "ads.txt line 2" },
    { level: "warn", title: "Missing TAG ID", detail: "Line 4 does not include a certification authority ID.", location: "ads.txt line 4" },
    { level: "info", title: "AdSense timing", detail: "Google says changes can take days, and low-request sites may take up to a month.", location: "AdSense status" }
  ],
  summary: {
    authorizedSellers: 3,
    resellers: 2,
    directives: 1,
    errors: 0,
    warnings: 2,
    notices: 1
  },
  generated: {
    adsLine: "google.com, pub-1234567890123456, DIRECT, f08c47fec0942fa0",
    adsTxt:
      "google.com, pub-1234567890123456, DIRECT, f08c47fec0942fa0\nmediavine.com, 12345, DIRECT, 123abc456def789ghi\nappnexus.com, 10260, RESELLER, 1234abcd5678efgh",
    robotsAllow: "User-agent: *\nAllow: /ads.txt",
    fixRequest:
      "Hello,\n\nPlease update the ads.txt file for example.com with these changes:\n\n- Keep the Google AdSense DIRECT line exactly as shown.\n- Add a TAG ID for appnexus.com on line 4.\n- Confirm /ads.txt returns HTTP 200 from both HTTP and HTTPS requests.\n\nRecommended ads.txt:\n\n```txt\ngoogle.com, pub-1234567890123456, DIRECT, f08c47fec0942fa0\nmediavine.com, 12345, DIRECT, 123abc456def789ghi\nappnexus.com, 10260, RESELLER, 1234abcd5678efgh\n```\n\nThank you.",
    report:
      "# AdTrust Inspector report for example.com\n\nScore: 84/100\n\n- ads.txt: 200 OK\n- Publisher ID: found\n- robots.txt: /ads.txt allowed\n- Issues: 2 warnings, 1 notice"
  }
};
